import React, { useEffect } from 'react';
import {
    useProperty,
    usePropertyComplementaryData,
    usePropertyFetching,
    usePropertyValidation,
} from '../../../contextsProperty/ContextProperties';
import TextInput from '../../../../muiComponents/TextInput/TextInputV2';
import LoadedOptionsTypeahead from '../../../../muiComponents/LoadedOptionsTypeahead';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import { fullColumnGrid } from '../../../../utils/property/propertyUtils';
import { PROGRESS_MAIN_INFORMATION_TAB } from '../../../../types/properties/propertyTypes';
import '../../../../stylesheets/stylesLayout/yourProperties.scss';
import LoadingTab from '../LoadingTab';
import Title from '../Title';
import Card from '../../../../muiComponents/Card';
import {
    gridSpacing30,
    gridSpacing40,
} from '../../../../utils/commonVariables/grid';

export default function Commercial() {
    const { isFetching } = usePropertyFetching();

    const { primary, idTimeZone, airportCode, handleInputChange } =
        useProperty();
    const { handleIsValidated, errors, isValidated, handleValidate } =
        usePropertyValidation();
    const { timeZonesList } = usePropertyComplementaryData();

    useEffect(() => {
        return () => handleIsValidated(false);
    }, []);

    const handleBlur = () => {
        if (isValidated) {
            handleValidate(PROGRESS_MAIN_INFORMATION_TAB.AREA);
        }
    };

    const autocompleteInputProps = {
        sx: {
            '& .MuiOutlinedInput-root': {
                height: '50px',
                fontSize: '1.2rem',
            },
            '& .MuiFilledInput-root': {
                height: '50px',
                fontSize: '1.2rem',
            },
            '& .MuiInputLabel-shrink': {
                top: '0 !important',
            },
            '& .MuiInputLabel-outlined': {
                fontSize: '1.2rem',
                // top: '-5px',
            },
            '& .MuiInputLabel-filled': {
                fontSize: '1.2rem',
                top: '-5px',
            },
        },
        variant: !primary ? 'filled' : 'outlined',
    };

    if (isFetching) {
        return <LoadingTab />;
    }

    return (
        <div className='your-property__container'>
            <Title as='h1' text={'area_title'} className='text-align-center' />
            <Card className='your-properties__form'>
                <Grid columnSpacing={gridSpacing30} rowSpacing={gridSpacing40}>
                    <GridChild gridProps={fullColumnGrid}>
                        <TextInput
                            labelText='nearest_airport_code'
                            handleChange={e =>
                                handleInputChange('airportCode', e.target.value)
                            }
                            value={airportCode || ''}
                            name='airportCode'
                            type='text'
                            disabled={!primary}
                            variant={!primary ? 'filled' : 'outlined'}
                        />
                    </GridChild>
                    <GridChild gridProps={fullColumnGrid}>
                        <LoadedOptionsTypeahead
                            labelText='time_zone'
                            options={timeZonesList}
                            handleChange={(e, newValue) => {
                                handleInputChange(
                                    'idTimeZone',
                                    newValue ? parseInt(newValue.id) : 0
                                );
                            }}
                            idValueKey='id'
                            optionsLabelKey='name'
                            idValue={idTimeZone || 0}
                            onBlur={handleBlur}
                            errorMessage={errors.idTimeZone}
                            required
                            disabled={!primary}
                            error={!!errors.idTimeZone}
                            inputProps={autocompleteInputProps}
                            name={'idTimeZone'}
                        />
                    </GridChild>
                </Grid>
            </Card>
        </div>
    );
}
